import React, { useMemo } from "react";
import "./WildLifeTourism.scss";
import Tabs from "calcite-react/Tabs/Tabs";
import TabNav from "calcite-react/Tabs/TabNav";
import TabTitle from "calcite-react/Tabs/TabTitle";
import TabContents from "calcite-react/Tabs/TabContents";
import TabSection from "calcite-react/Tabs/TabSection";
import useQueryString from "../../../hooks/useQueryString";
import WhaleDolphin from "./WhaleDolphin/WhaleDolphin";
import Bird from "./Bird/Bird";
import GeoSelector from "../../GeoSelector/GeoSelector";
import GeoScale from "../../GeoScale/GeoScale";

function WildLifeTourism() {
  const [selectedApp, setSelectedApp] = useQueryString("selectedApp", 0);

  const [selectedGeometry, setSelectedGeometry] = useQueryString(
    "wdSelectedGeometry",
    "CROP Countries"
  );
  const [isGeoScaled, setIsGeoScaled] = useQueryString("wdIsGeoScaled", false);

  const geoWhaleSelections = useMemo(
    () => [
      "CROP Countries",
      "Dominica",
      "Grenada",
      // "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
    ],
    []
  );

  const geoBirdSelections = useMemo(
    () => [
      "CROP Countries",
      "Dominica",
      "Grenada",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
    ],
    []
  );

  const onTabChange = (index) => {
    setSelectedApp(index);
    //if geography is missing on switched tab, reset to the region
    let geoMissing = !index
      ? !geoWhaleSelections.includes(selectedGeometry)
      : !geoBirdSelections.includes(selectedGeometry);

    if (geoMissing) {
      setSelectedGeometry("CROP Countries");
      //auto-scale data if anything is selected
      setIsGeoScaled(false);
    }
  };

  /**
   * Simple handler for when the user selects a new geometry. Update in state
   */
  const handleGeometryChange = (geometry) => {
    setSelectedGeometry(geometry);
    //auto-scale data if anything is selected
    setIsGeoScaled(geometry !== "CROP Countries");
  };

  /**
   * Simple handler for when the user toggle the geo scaler. Update in state
   */
  const onGeoScaleToggle = () => {
    setIsGeoScaled(!isGeoScaled);
  };

  return (
    <div className="wildlifeTourism">
      <p className="instructions">
        {Number(selectedApp) === 0 &&
          "Explore the intensity, distribution, and values of whale and dolphin watching in four Eastern Caribbean countries (there was insufficient data to model this activity for St. Kitts & Nevis)."}
        {Number(selectedApp) === 1 &&
          "Explore the distribution and intensity of birdwatching in five Eastern Caribbean countries, and click on individual protected areas or important bird areas to view statistics for that area."}
      </p>
      <div className="geoSelect">
        <GeoSelector
          selectedGeometry={selectedGeometry}
          handleOnChange={handleGeometryChange}
          selections={
            Number(selectedApp) === 0 ? geoWhaleSelections : geoBirdSelections
          }
        />
        <GeoScale geoScaled={isGeoScaled} onToggle={onGeoScaleToggle} />
      </div>
      <Tabs onTabChange={onTabChange} activeTabIndex={Number(selectedApp)}>
        <TabNav className="tour-tabs">
          <TabTitle
            className={`tour-tab-title ${
              Number(selectedApp) === 0 ? "active" : null
            }`}
          >
            Whale &amp; Dolphin Watching
          </TabTitle>
          <TabTitle
            className={`tour-tab-title ${
              Number(selectedApp) === 1 ? "active" : null
            }`}
          >Bird Watching</TabTitle>
        </TabNav>
        <TabContents className="tab-contents">
          <TabSection>
            <WhaleDolphin
              selectedGeometry={selectedGeometry}
              isGeoScaled={isGeoScaled}
              geoSelections={geoWhaleSelections}
            />
          </TabSection>
          <TabSection>
            <Bird
              selectedGeometry={selectedGeometry}
              isGeoScaled={isGeoScaled}
              geoSelections={geoBirdSelections}
            />
          </TabSection>
        </TabContents>
      </Tabs>
    </div>
  );
}

export default WildLifeTourism;
